import { type SVGProps, memo } from "react";
import React from "react";
import type { IconName } from "./names";

import { cn } from "../../../util/classNameConstructor";

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "name"> {
  name: IconName | React.ReactNode;
  label?: string;
  className?: string;
}

const Icon = ({ name, label, className, ...props }: IconProps) => {
  const loading = name === "loading";
  const iconName = loading ? "spinner" : name;

  if (!iconName) return null;
  if (typeof iconName === "function" || React.isValidElement(iconName)) {
    return iconName;
  }
  if (typeof iconName !== "string") return null;

  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      name={String(label || name)}
      {...props}
      className={cn(
        "pointer-events-none",
        className,
        loading ? "animate-revolve" : "",
      )}
      role="presentation"
      aria-hidden="true"
    >
      <title>{label || name || ""}</title>
      <use href={`#${iconName}`} />
    </svg>
  );
};

Icon.displayName = "Icon";
export default memo(Icon);
